import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import {
  arrayOf,
  customType,
  extend,
  namedFragment,
  params,
  shape,
  string,
  typename,
  useDataModel,
} from '@thd-nucleus/data-sources';
import { useImpression } from '@thd-olt-component-react/impression';
import { KidsWorkshopsRegistration } from '@thd-olt-component-react/kids-workshops-registration';
import { withImpressions } from '../hocs/withImpressions';
import { MedioComposableBannerRenderer } from './MedioComposableBannerRenderer';

const { number: numberType, string: stringType } = proptypes;

const MedioComposableBanner = withImpressions(({
  componentClass = '',
  componentId,
  componentPosition = 1,
  fetchpriority,
  enableB2CRadius = false
}) => {
  const { ref, clickID } = useImpression({
    data: {
      id: componentId,
      name: MedioComposableBanner.displayName,
      component: MedioComposableBanner.displayName,
      position: componentPosition,
      type: 'content',
    },
  });

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('medio-composable-banner.ready');
  }, []);

  const { data, loading, error } = useDataModel('component', {
    variables: {
      componentClass,
      id: componentId,
    },
  });

  if (!data || loading || error) {
    return null;
  }

  return (
    <div
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      data-component-id={componentId}
      data-component-name="MedioComposableBanner"
      data-component-position={componentPosition}
      data-component="MedioComposableBanner"
      id={`${componentClass}-${componentPosition}-${componentId}`}
    >
      <MedioComposableBannerRenderer data={data.component} fetchpriority={fetchpriority} enableB2CRadius={enableB2CRadius} />
    </div>
  );
});

MedioComposableBanner.propTypes = {
  componentClass: stringType,
  componentId: stringType.isRequired,
  componentPosition: numberType,
  fetchpriority: stringType,
  enableB2CRadius: proptypes.bool,
};

MedioComposableBanner.displayName = 'MedioComposableBanner';

// Do not touch
const DamMediaFragment = namedFragment({
  inline: false,
  fragmentType: 'DamMedia',
  fragmentAlias: 'DamMediaV1',
}).shape({
  damContentSelector: shape({
    assetData: arrayOf(
      shape({
        selectedImageUrl: string(),
      })
    ),
  }),
  damDownloadedContent: shape({
    url: string(),
  }),
  id: string(),
  __typename: typename('DamMedia'),
});

MedioComposableBanner.dataModel = extend({
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['MedioComposableBanner']).isRequired(),
  }).shape({
    MedioComposableBanner: namedFragment({
      inline: true,
      fragmentType: 'MedioComposableBanner',
    }).shape({
      componentName: string(),
      id: string(),
      image: DamMediaFragment,
      altText: string(),
      smallMedia: DamMediaFragment,
      altTextSmallMedia: string(),
      title: string(),
      subtitle: string(),
      cta: string(),
      destinationUrl: string(),
      legalCopy: shape({
        legalText: string(),
        legalUrl: string(),
      }),
      overrideAction: string(),
    }),
  }),
}, KidsWorkshopsRegistration);

export { MedioComposableBanner };
